export default __webpack_public_path__ + "static/media/002-crossroads.abff42d3.png";